import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { class: "col-12 col-md-6" }
const _hoisted_3 = { class: "row q-col-gutter-md" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "text-bold" }
const _hoisted_6 = {
  key: 0,
  style: {"font-style":"unset"}
}
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["href"]

import {computed, PropType} from 'vue';
import {Business} from 'src/models/business.model';
import {openExternalLink} from 'src/etc/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoTabPanel',
  props: {
  business: {
    type: Object as PropType<Business>,
    required: true
  }
},
  setup(__props) {

const props = __props

const getMapsLink = computed(() => {
  let url
  if (props.business.address?.latitude && props.business.address?.longitude) {
    url = `https://maps.google.de/maps?q=${props.business.address?.latitude},${props.business.address?.longitude}`
  } else {
    url = `https://maps.google.de/maps?q=${props.business.address?.address_line}`
  }
  return url
})


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.business.name), 1),
          (__props.business.address)
            ? (_openBlock(), _createElementBlock("address", _hoisted_6, [
                _createElementVNode("div", null, _toDisplayString(`${[__props.business.address.street_and_number, __props.business.address.addition].join(' ').trim()}`), 1),
                _createElementVNode("div", null, _toDisplayString(__props.business.address.city) + " " + _toDisplayString(__props.business.address.zip_code), 1),
                _createElementVNode("div", null, _toDisplayString(__props.business.address.country_display), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (__props.business.phone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_q_icon, {
                  name: "fas fa-phone",
                  size: "0.7rem"
                }),
                _cache[3] || (_cache[3] = _createTextVNode("  ")),
                _createElementVNode("a", {
                  href: `tel:${__props.business.phone}`,
                  rel: "noreferrer noopener",
                  target: "_blank"
                }, _toDisplayString(__props.business.phone), 9, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          (__props.business.website)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_q_icon, {
                  name: "fas fa-link",
                  size: "0.7rem"
                }),
                _cache[4] || (_cache[4] = _createTextVNode("  ")),
                _createElementVNode("a", {
                  href: __props.business.website,
                  rel: "noopener nofollow",
                  target: "_blank",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(openExternalLink)(__props.business.website)), ["prevent"]))
                }, "Webseite", 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true),
          (__props.business.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_q_icon, {
                  name: "fas fa-map",
                  size: "0.7rem"
                }),
                _cache[5] || (_cache[5] = _createTextVNode("  ")),
                _createElementVNode("a", {
                  href: getMapsLink.value,
                  rel: "noreferrer noopener nofollow",
                  target: "_blank"
                }, " Google Maps ", 8, _hoisted_13)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (__props.business.imprint_link)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("a", {
                  rel: "external nofollow noreferrer noopener",
                  href: __props.business.imprint_link,
                  referrerpolicy: "no-referrer-when-downgrade",
                  target: "_blank",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(openExternalLink)(__props.business.imprint_link)), ["prevent"]))
                }, " Impressum ", 8, _hoisted_16),
                _cache[6] || (_cache[6] = _createTextVNode("  ")),
                _createVNode(_component_q_icon, {
                  name: "fas fa-external-link",
                  size: "0.7rem"
                })
              ]))
            : _createCommentVNode("", true),
          (__props.business.privacy_link)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("a", {
                  rel: "external nofollow noreferrer noopener",
                  href: __props.business.privacy_link,
                  referrerpolicy: "no-referrer-when-downgrade",
                  target: "_blank",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(openExternalLink)(__props.business.privacy_link)), ["prevent"]))
                }, " Datenschutz ", 8, _hoisted_18),
                _cache[7] || (_cache[7] = _createTextVNode("  ")),
                _createVNode(_component_q_icon, {
                  name: "fas fa-external-link",
                  size: "0.7rem"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})